import { render, staticRenderFns } from "./productInformation.vue?vue&type=template&id=3beca513&scoped=true&"
import script from "./productInformation.vue?vue&type=script&lang=ts&"
export * from "./productInformation.vue?vue&type=script&lang=ts&"
import style0 from "./productInformation.vue?vue&type=style&index=0&id=3beca513&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3beca513",
  null
  
)

export default component.exports